import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { CustomerBilling } from "./CustomerBilling";
import CustomerBillingQueryNode, {
  type CustomerBillingQuery$variables,
} from "./__generated__/CustomerBillingQuery.graphql";

const entryPoint: SimpleEntryPoint<typeof CustomerBilling> = {
  root: JSResource("CustomerBilling", () =>
    import("./CustomerBilling").then((module) => module.CustomerBilling),
  ),
  getPreloadProps({ params }) {
    const variables: CustomerBillingQuery$variables = {
      customerBillingId: params.customerBillingId!,
    };

    return {
      queries: {
        query: {
          parameters: CustomerBillingQueryNode,
          variables,
          options: {
            fetchPolicy: "store-and-network",
          },
        },
      },
    };
  },
};

export default entryPoint;
